import { render, staticRenderFns } from "./SceneOrder.vue?vue&type=template&id=0edcbd1f&scoped=true&"
import script from "./SceneOrder.vue?vue&type=script&lang=js&"
export * from "./SceneOrder.vue?vue&type=script&lang=js&"
import style0 from "./SceneOrder.vue?vue&type=style&index=0&id=0edcbd1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edcbd1f",
  null
  
)

export default component.exports